import bbtNative from './bbtNative';
let sequence = 0;
export const wrap = function (callback) {
    if (bbtNative.isReady) {
        return callback.call(undefined, bbtNative);
    }
    sequence += 1;
    window.setTimeout(function () {
        sequence -= 1;
        bbtNative.ready(callback);
    }, sequence * 35);
};
